module.exports = __webpack_public_path__ + "static/life-e8e09ae5a780dc214b6f0f3a9ebb511c.jpg";